export enum EncounterAnswersLinkIds {
  // Encounter Notes
  Note = "encounterNote",
  ClientSummary = "encounterClientSummary",

  // Prenatal Flow Sheet
  FlowSheetDate = "encounterFlowSheetDate",
  FlowSheetWeight = "encounterFlowSheetWeight",
  FlowSheetWeightUnit = "encounterFlowSheetWeightUnit",
  FlowSheetSystolicBP = "encounterFlowSheetSystolicBP",
  FlowSheetDiastolicBP = "encounterFlowSheetDiastolicBP",
  FlowSheetHeartRate = "encounterFlowSheetHeartRate",
  FlowSheetFundalHeight = "encounterFlowSheetFundalHeight",
  FlowSheetFundalHeightUnit = "encounterFlowSheetFundalHeightUnit",
  FlowSheetFetalPresentation = "encounterFlowSheetFetalPresentation",
  FlowSheetFetalHeartRate = "encounterFlowSheetFetalHeartRate",
  FlowSheetFetalMovement = "encounterFlowSheetFetalMovement",
  FlowSheetUrineProtein = "encounterFlowSheetUrineProtein",
  FlowSheetUrineGlucose = "encounterFlowSheetUrineGlucose",
  FlowSheetEdema = "encounterFlowSheetEdema",
  FlowSheetNotes = "encounterFlowSheetNotes",

  // Vitals
  VitalsWeight = "encounterVitalSignsWeight",
  VitalsWeightUnit = "encounterVitalSignsWeightUnit",
  VitalsHeightUnit = "encounterVitalSignsHeightUnit",
  VitalsHeightFeet = "encounterVitalSignsHeightFeet",
  VitalsHeightInches = "encounterVitalSignsHeightInches",
  VitalsHeightCm = "encounterVitalSignsHeightCm",
  VitalsSystolicBP = "encounterVitalSignsSystolicBP",
  VitalsDiastolicBP = "encounterVitalSignsDiastolicBP",
  VitalsHeartRate = "encounterVitalSignsHeartRate",
  VitalsTemperature = "encounterVitalSignsTemperature",
  VitalsTemperatureUnit = "encounterVitalSignsTemperatureUnit",
  VitalsTemperatureMethod = "encounterVitalSignsTemperatureMethod",
  VitalsRespiratoryRate = "encounterVitalSignsRespiratoryRate",
  VitalsGeneralAppearance = "encounterVitalSignsGeneralAppearance",
  VitalsComments = "encounterVitalSignsVitalsComments",

  // Encounter Details
  EncounterTemplate = "encounterTemplate",
  EncounterType = "encounterType",
  EncounterLocation = "encounterLocation",
  EncounterStartDate = "encounterStartDate",
  EncounterStartDateTimezone = "encounterStartDateTimezone",

  // Encounter Amendment Info
  EncounterAmendmentInfoReason = "encounterAmendmentInfoReason",
  EncounterAmendmentInfoSpecify = "encounterAmendmentInfoSpecify",
  EncounterAmendmentInfoNotes = "encounterAmendmentInfoNotes",
  EncounterAmendmentInfoNotifyClient = "encounterAmendmentInfoNotifyClient",
}
